export default {
  dashboard: 'My events',
  accountDetails: 'My profile',
  event: {
    create: 'Create event',
    update: 'Edit event',
    // upgrade: 'Upgrade your event',
  },
  subscriptionPlans: 'Eventor subscription plans',
  teamManagement: 'Manage your team',
};
